import * as Yup from 'yup'
import { csvInputSchema } from './common'

const validationSchema = Yup.object().shape({
  categoryId: Yup.number().required('Categoyr is required'),
  subCategoryId: Yup.number().required('Sub Category is required'),
  file: csvInputSchema,
})

const addValidationSchema = Yup.object().shape({
  name: Yup.string().required('Medicine name is required'),
  duration: Yup.string().required('Duration is required'),
  consumptions: Yup.array().of(Yup.string().required()).min(1).required(),
  notes: Yup.string().notRequired(),
})

export default {
  validationSchema,
  addValidationSchema,
}
